import { render, staticRenderFns } from "./ComboCampanha.vue?vue&type=template&id=3b394906"
import script from "./ComboCampanha.vue?vue&type=script&lang=ts"
export * from "./ComboCampanha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports